import { render, staticRenderFns } from "./statusDetail.vue?vue&type=template&id=753acac8&scoped=true&"
import script from "./statusDetail.vue?vue&type=script&lang=js&"
export * from "./statusDetail.vue?vue&type=script&lang=js&"
import style0 from "./statusDetail.vue?vue&type=style&index=0&id=753acac8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753acac8",
  null
  
)

export default component.exports